/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { NgClass, NgComponentOutlet, NgTemplateOutlet } from "@angular/common";
import { Component, Inject, signal, Signal, TemplateRef, Type } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle
} from "@angular/material/dialog";
import { DialogCloseReason } from "../../models/ui/dialog-close-reason.model";
import { DialogDataOptions } from "../../models/ui/dialog-data-options.model";
import { ButtonComponent } from "../button/button.component";

@Component({
	selector: "globalictcc-dialog",
	standalone: true,
	imports: [
		MatDialogContent,
		MatDialogTitle,
		MatDialogActions,
		ButtonComponent,
		NgClass,
		NgTemplateOutlet,
		NgComponentOutlet
	],
	templateUrl: "./dialog.component.html",
	styleUrl: "./dialog.component.scss"
})
export class DialogComponent {
	public title: string = "";
	public message: string = "";
	public iconName: string = "";
	public type: string = "";
	public content: TemplateRef<unknown>;
	public customComponent?: Type<unknown>;
	public customComponentInputs?: Record<string, unknown>;
	public closeBtnText: string = "Close";
	public isConfirmActionDisabled: Signal<boolean> = signal(false);
	public confirmBtnText: string = "Confirm";
	public confirmAction: () => void = () => {};
	public cancelBtnText: string = "Cancel";
	public isIconVisible: boolean = false;

	constructor(
		private _dialogRef: MatDialogRef<DialogComponent, DialogCloseReason>,
		@Inject(MAT_DIALOG_DATA) private _data: DialogDataOptions
	) {
		Object.assign(this, this._data);
	}

	/**
	 * Closes the dialog.
	 *
	 * This method uses the `_dialogRef` service to close the currently open dialog.
	 */
	public close() {
		this._dialogRef.close("CANCELED");
	}

	/**
	 * Closes the dialog and triggers the confirm action.
	 *
	 * This method first calls the `close` method to close the dialog,
	 * and then calls the `confirmAction` method to perform the confirmation action.
	 */
	public confirm() {
		this._dialogRef.close("CONFIRMED");
		this.confirmAction();
	}
}
